import { createBreakpoints } from '@chakra-ui/theme-tools';

export const breakpoints = createBreakpoints({
  xs: '14em',
  sm: '30em',
  md: '48em',
  base: '48em',
  lg: '62em',
  xl: '80em',
});
